module.exports = __webpack_public_path__ + "assets/images/tz_dubrovnik_airport.png";